export default "/images/instagram.svg?7d97391465d60f2909c444d267ea80ff";